var SURROGATE_START = 0xd800;
var SURROGATE_END = 0xdfff;
export function isSurrogate(code) {
  return SURROGATE_START <= code && code <= SURROGATE_END;
}